export const CHECKOUT_STEPS = {
  PATIENT: 1,
  PHONE_VERIFICATION: 2,
  CONFIRMATION: 3,
};

export const EMAIL = 'email';
export const PHONE = 'phone';

export const SMS_DELIVERED_STATUS = 'DELIVERED';
export const SMS_FAILED_STATUS = ['UNDELIVERED', 'REJECTED'];

export const displayPreferences = [
  { label: 'Early (Before 9am)', value: 'early' },
  { label: 'Morning (9am - 12pm)', value: 'morning' },
  { label: 'Noon (12pm - 2pm)', value: 'noon' },
  { label: 'Afternoon (2pm - 5pm)', value: 'afternoon' },
  { label: 'Evening (After 5pm)', value: 'evening' },
  { label: 'Weekends (Sat - Sun)', value: 'weekends' },
];

export const contactPreferences = [
  { label: 'Phone Call', value: 'phone' },
  { label: 'SMS', value: 'sms' },
];

export enum SSO_PROVIDERS {
  GOOGLE = 'google',
  FACEBOOK = 'facebook',
  APPLE = 'apple',
}

export const SSO_REDIRECT = 'ssoRedirect';
export const SSO_APPOINTMENT = {
  PROVIDER: 'provider',
  SLOT: 'slot',
  ANY_PROVIDER: 'any_provider',
};
